import { CommaSeparator } from '@/components/custom';
import { Ban } from 'lucide-react';

type TProps = {
	user: {
		deviceBanCount?: number;
	}
}

const BannerUserInfosBan = ({ user }: TProps) => {

	const deviceBanCount = user?.deviceBanCount ?? 0;

	if (deviceBanCount <= 0) {
		return <></>;
	}

	return (
		<>
			<CommaSeparator />
			<div
				className='flex items-center space-x-1 text-red-600 text-sm font-semibold'
				title={`Déjà banni ${deviceBanCount} fois`}>
				<span>
					{deviceBanCount}
				</span>
				<Ban
					size={16} />
			</div>
		</>
	);

};

export default BannerUserInfosBan;
